import { CoachingAdvice, CoachingAdviceResource } from './CoachingAdvice';

export const transformToCoachingAdvice = (
    coachingAdviceResource: CoachingAdviceResource,
): CoachingAdvice => ({
    id: coachingAdviceResource.id,
    label: coachingAdviceResource.label,
    advices: coachingAdviceResource.coachingTips,
});
